// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#WSIQkd5gjhytUywej8mo{display:flex;flex-wrap:wrap;gap:8px;width:100%}`, "",{"version":3,"sources":["webpack://./components/HeaderComponent/HeaderComponent.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,cAAA,CACA,OAAA,CACA,UAAA","sourcesContent":["#headerContainer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `WSIQkd5gjhytUywej8mo`
};
export default ___CSS_LOADER_EXPORT___;
